/**
 * Crew book kinds.
 *
 * A crew member is a person who works on a job. A supplier is a business,
 * such as a rental house, that only supplies equipment: it has a kit list and a
 * markup but no day rate, no super and no dietaries. Records saved before the
 * field existed have no `kind`, and they are crew.
 *
 * The backend's twin is `CrewKind` in models.py, with the super rule in
 * crew_service.py.
 */

export const CREW_KINDS = {
  crew: { label: 'Crew member', groupLabel: 'Crew' },
  supplier: { label: 'Supplier', groupLabel: 'Suppliers' },
};

export const crewKind = (member) => (member?.kind === 'supplier' ? 'supplier' : 'crew');

export const isSupplier = (member) => crewKind(member) === 'supplier';

/**
 * Active members of the given kinds, grouped in the order the kinds are
 * listed. Empty groups are left out.
 */
export function groupCrewByKind(members, kinds = ['crew', 'supplier']) {
  const active = (members || []).filter((m) => m.status === 'active');
  return kinds
    .map((kind) => ({
      kind,
      label: CREW_KINDS[kind].groupLabel,
      members: active.filter((m) => crewKind(m) === kind),
    }))
    .filter((group) => group.members.length > 0);
}
